import axios from 'axios';
import { getAccessToken, getRefreshToken, saveTokens, clearTokens, isTokenExpired } from '../utils/tokenHelper';

const BASE_URL = 'https://koplpune.in/kopld/api';
//const BASE_URL = 'https://localhost:7287/api';
//const BASE_URL = 'https://corsproxy.io/?https://koplpune.in/kopld/api';
const api = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' }
});

// ── Attach JWT token to every request ────────────────
api.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) config.headers['Authorization'] = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// ── Auto refresh on 401 ───────────────────────────────
let isRefreshing = false;
let failedQueue  = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(p => error ? p.reject(error) : p.resolve(token));
  failedQueue = [];
};

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;

    // If blob response errored, convert to JSON to read status
    if (error.response?.config?.responseType === 'blob' && error.response?.data instanceof Blob) {
      try {
        const text = await error.response.data.text();
        const json = JSON.parse(text);
        error.response.data = json;
      } catch { /* leave as blob */ }
    }

    // Only handle 401, skip if already retried or is a refresh/login call
    if (
      error.response?.status === 401 &&
      !original._retry &&
      !original.url?.includes('/auth/')
    ) {
      if (isRefreshing) {
        // Queue this request until refresh completes
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
        .then(token => {
          original.headers['Authorization'] = `Bearer ${token}`;
          return api(original);
        })
        .catch(err => Promise.reject(err));
      }

      original._retry = true;
      isRefreshing = true;

      const refreshTk = getRefreshToken();
      if (!refreshTk) {
        // No refresh token — clear and redirect to login
        clearTokens();
        window.location.href = '/login';
        return Promise.reject(error);
      }

      try {
        const res = await axios.post(`${BASE_URL}/auth/refresh-token`, {
          refreshToken: refreshTk
        });

        if (res.data?.success) {
          const { accessToken, refreshToken } = res.data.data;
          saveTokens(accessToken, refreshToken);
          api.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
          original.headers['Authorization'] = `Bearer ${accessToken}`;
          processQueue(null, accessToken);
          return api(original);
        } else {
          // Refresh failed — go to login
          processQueue(error, null);
          clearTokens();
          window.location.href = '/login';
          return Promise.reject(error);
        }
      } catch (refreshError) {
        processQueue(refreshError, null);
        clearTokens();
        window.location.href = '/login';
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export const registerSendOtp   = (data) => api.post('/auth/register/send-otp',        data);
export const registerVerifyOtp = (data) => api.post('/auth/register/verify-otp',      data);
export const registerComplete  = (data) => api.post('/auth/register/complete',         data);
export const login             = (data) => api.post('/auth/login',                     data);
export const forgotPwSendOtp   = (data) => api.post('/auth/forgot-password/send-otp', data);
export const forgotPwReset     = (data) => api.post('/auth/forgot-password/reset',    data);
export const refreshToken      = (data) => api.post('/auth/refresh-token',            data);
export const logout            = (data) => api.post('/auth/logout',                   data);

export default api;